module.exports = __webpack_public_path__ + "assets/images/amira.1017dea7d083ce6938b777d39ef369c9.svg";